import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
        <h4 className='my-3'>Franklin Community Schools</h4>
        <a href='https://www.franklinschools.org' target='_blank' className='footer-link'><h4 className='my-3'>franklinschools.org</h4></a>
    </div>
  )
}
